<template>
  <div>
    <!-- Employee Verification -->
    <div v-if="showVerification" class="padTop">
      <v-layout justify-center align-content-center fill-height>
        <v-flex xs11 v-if="$vuetify.breakpoint.smAndDown">
          <verification
            :mainColor="this.mainColor"
            :entity="this.entity"
            :retryVerification="retryVerification"
          ></verification>
        </v-flex>
        <v-flex xs11 v-if="$vuetify.breakpoint.mdAndUp">
          <verification
            class="addPadding"
            :mainColor="this.mainColor"
            :entity="this.entity"
            :retryVerification="retryVerification"
          ></verification>
        </v-flex>
      </v-layout>
    </div>

    <!-- Alt Demographics -->
    <div v-if="showAltDemographics" class="padTop">
      <v-layout justify-center align-content-center fill-height>
        <v-flex xs11 v-if="$vuetify.breakpoint.smAndDown">
          <altDemographics
            :mainColor="this.mainColor"
            :entity="this.entity"
          ></altDemographics>
        </v-flex>
        <v-flex xs11 v-if="$vuetify.breakpoint.mdAndUp">
          <altDemographics
            class="addPadding"
            :mainColor="this.mainColor"
            :entity="this.entity"
          ></altDemographics>
        </v-flex>
      </v-layout>
    </div>

    <!-- Proposed Insureds Demographics -->
    <div v-if="showDemographics" class="padTop">
      <v-layout justify-center align-content-center fill-height>
        <v-flex xs11 v-if="$vuetify.breakpoint.smAndDown">
          <tmkProposedInsureds
            :mainColor="this.mainColor"
            :entity="this.entity"
          ></tmkProposedInsureds>
        </v-flex>
        <v-flex xs11 v-if="$vuetify.breakpoint.mdAndUp">
          <tmkProposedInsureds
            class="addPadding"
            :mainColor="this.mainColor"
            :entity="this.entity"
          ></tmkProposedInsureds>
        </v-flex>
      </v-layout>
    </div>
    <!-- Eligible Products, Product Questions and Rates -->
    <div v-if="showProducts" class="padTop">
      <v-layout justify-center align-content-center fill-height>
        <v-flex xs11 v-if="$vuetify.breakpoint.smAndDown">
          <tmkProductsAndQuestions
            :mainColor="this.mainColor"
            :entity="this.entity"
          ></tmkProductsAndQuestions>
        </v-flex>
        <v-flex xs11 v-if="$vuetify.breakpoint.mdAndUp">
          <tmkProductsAndQuestions
            class="addPadding"
            :mainColor="this.mainColor"
            :entity="this.entity"
          ></tmkProductsAndQuestions>
        </v-flex>
      </v-layout>
    </div>
    <!-- Submit Confirmation and Redirect -->
    <!-- <div v-if="showSubmit" class="padTop">
      <v-layout justify-center align-content-center fill-height>
        <v-flex xs5 class="pr-3">
          <v-img
            :src="require('@/assets/hands_in_2.png')"
            aspect-ratio="2.5"
            contain
            class="padTopThankYouImg"
            height="350"
          ></v-img>
        </v-flex>
      </v-layout>
      <br>
      <br>
      <h3>
        <strong>Thank you.</strong>
      </h3>
      <p>
        <i>
          You will be redirected in 10 seconds.
          <br>If you are not redirected, please click
          <a :href="redirectUrl">here</a> to continue.
        </i>
      </p>
    </div>
  </div>
    -->

    <v-dialog v-model="waitDialog" persistent width="500">
      <template>
        <v-window
          :v-if="waitDialog"
          v-model="windowModel"
          :show-arrows="false"
          width="500"
        >
          <v-window-item>
            <v-card color="white" height="250">
              <br />
              <br />
              <v-layout justify-center align-content-center>
                <v-card-title class="headline" :style="{ color: mainColor }"
                  >Thank You</v-card-title
                >
              </v-layout>

              <v-card-text :style="{ color: mainColor }"
                >You will be redirected to DocuSign to complete your application
                shortly.</v-card-text
              >
              <br />
              <br />
            </v-card>
          </v-window-item>
          <v-window-item>
            <v-card height="250" color="white">
              <br />
              <br />
              <br />
              <br />
              <v-card-text :style="{ color: mainColor }">
                An email containing the details of your application
                <br />will be sent to the address you have provided.
              </v-card-text>
              <br />
              <br />
            </v-card>
          </v-window-item>
          <v-window-item>
            <v-card class="waitCard" height="250" color="white">
              <br />
              <br />
              <br />

              <v-card-text :style="{ color: mainColor }">
                Thank you for your patience.
                <br />
                <br />We’re gathering all of the forms and getting them ready
                for you to sign!
              </v-card-text>
              <br />
              <br />
            </v-card>
          </v-window-item>
        </v-window>
        <!-- </div> -->
      </template>
    </v-dialog>

    <v-dialog v-model="errorDialog" width="500">
      <v-card color="white">
        <v-card-title
          class="headline"
          primary-title
          :style="{ color: mainColor }"
        >
          <v-layout justify-center align-content-center
            >Something Went Wrong</v-layout
          >
        </v-card-title>
        <v-card-text :style="{ color: mainColor }">
          We are unable to redirect you to DocuSign to complete the application
          process at this time. Please try again later or contact us at
          <a href="mailto:ESD_SofNM@globe.life" style="text-decoration: none"
            >ESD_SofNM@globe.life</a
          >
          for help.
        </v-card-text>
        <br />
        <br />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import tmkProposedInsureds from '../components/tmk-proposed-insureds.vue'
// import tmkProductsAndQuestions from '../components/tmk-products-and-questions.vue'

import eventBus from '../event-bus'
import store from '../store'

//import { HTTP } from '../http-common.js'

import logic from '../logic.js'

export default {
  name: 'Application',
  props: { mainColor: String, entity: Object },
  components: {
    verification: () =>
      import(
        /* webpackPrefetch: true */ '../components/employee-verification.vue'
      ),

    altDemographics: () =>
      import(/* webpackPrefetch: true */ '../components/alt-demographics.vue'),

    tmkProposedInsureds: () =>
      import(
        /* webpackPrefetch: true */ '../components/tmk-proposed-insureds.vue'
      ),
    tmkProductsAndQuestions: () =>
      import(
        /* webpackPrefetch: true */ '../components/tmk-products-and-questions.vue'
      ),

    // tmkProposedInsureds,
    // tmkProductsAndQuestions
  },
  mounted() {
    this.$nextTick(() => {
      // console.log(this.$store.state.productsFlag)

      if (this.$store.state.productsFlag == true) {
        this.showVerification = false
        this.showAltDemographics = false
        this.showDemographics = false
        this.showQuestions = false
        this.showProducts = true
        this.showSubmit = false
      }
    })

    eventBus.$on(
      'showSubmit',
      function () {
        this.showSubmitAndRedirect()
        window.scrollTo(0, 0)
      }.bind(this)
    )
    eventBus.$on(
      'showDemographics',
      function () {
        this.showDemographicsSection()
        window.scrollTo(0, 0)
      }.bind(this)
    )
    eventBus.$on(
      'showProducts',
      function () {
        this.showProductSection()
        window.scrollTo(0, 0)
      }.bind(this)
    )
    eventBus.$on(
      'showAltDemographics',
      function () {
        this.showAltDemographicsSection()
        window.scrollTo(0, 0)
      }.bind(this)
    )
    eventBus.$on(
      'showVerification',
      function () {
        this.retryVerification = true
        this.showVerificationSection()
        window.scrollTo(0, 0)
      }.bind(this)
    )
  },
  beforeDestroy() {
    eventBus.$off('showQuestions')
    eventBus.$off('showSubmit')
    eventBus.$off('showDemographics')
    eventBus.$off('showProducts')
    eventBus.$off('showAltDemographics')
  },
  computed: {
    redirectUrl: function () {
      return store.state.externalRoute
    },
    errorDialog: {
      get: function () {
        return store.state.showErrorDialog
      },
      set: function (newValue) {
        if (store.state.showErrorDialog === true) {
          // prevent the wait dialog from popping back
          // up after error is dismissed:
          this.dialog = false
        }
        store.commit('setShowErrorDialog', newValue)
      },
    },
    waitDialog: function () {
      return this.dialog && !store.state.showErrorDialog
    },
  },
  beforeRouteLeave(to, from, next) {
    // console.log('before leaving')
    this.save()
    next()
  },

  created() {
    // this.$nextTick(() => {
    //   if (this.$store.state.productsFlag==true) {
    //     this.showProductSection()
    //   }
    // })
    // var startPos
    // var geoSuccess = function(position) {
    //   startPos = position
    //   console.log(startPos.coords.latitude)
    //   console.log(startPos.coords.longitude)
    // }
    // var geoError = function(error) {
    //   console.log('Error occurred. Error code: ' + error.code)
    //   // error.code can be:
    //   //   0: unknown error
    //   //   1: permission denied
    //   //   2: position unavailable (error response from location provider)
    //   //   3: timed out
    // }
    // navigator.geolocation.getCurrentPosition(geoSuccess, geoError, {
    //   enableHighAccuracy: false,
    //   maximumAge: 60000,
    //   timeout: 10000
    // })
  },
  data: () => ({
    intro: false,
    showVerification: true,
    showAltDemographics: false,
    showDemographics: false,
    showQuestions: false,
    showProducts: false,
    showSubmit: false,
    dialog: false,
    windowModel: 0,
    windowPanesCount: 3,
    retryVerification: false,
  }),
  methods: {
    save() {
      this.$store.commit('setDemographicsFlag', this.showDemographics)
      this.$store.commit('setProductsFlag', this.showProducts)

      if (this.showDemographics) {
        eventBus.$emit('savePerson')
      } else if (this.showProducts) {
        eventBus.$emit('saveProducts')
      }
    },
    showVerificationSection() {
      this.showVerification = true
      this.showAltDemographics = false
      this.showDemographics = false
      this.showProducts = false
      this.showQuestions = false
      this.showSubmit = false
    },
    showAltDemographicsSection() {
      this.showVerification = false
      this.showAltDemographics = true
      this.showDemographics = false
      this.showProducts = false
      this.showQuestions = false
      this.showSubmit = false
    },
    showDemographicsSection() {
      this.showVerification = false
      this.showAltDemographics = false
      this.showDemographics = true
      this.showProducts = false
      this.showQuestions = false
      this.showSubmit = false
      this.$store.commit('setDemographicsFlag', true)
      this.$store.commit('setProductsFlag', false)
    },
    showQuestionSection() {
      this.showVerification = false
      this.showAltDemographics = false
      this.showDemographics = false
      this.showQuestions = true
      this.showProducts = false
      this.showSubmit = false
    },
    showProductSection() {
      this.showVerification = false
      this.showAltDemographics = false
      this.showDemographics = false
      this.showQuestions = false
      this.showProducts = true
      this.showSubmit = false
      this.$store.commit('setDemographicsFlag', false)
      this.$store.commit('setProductsFlag', true)
    },
    showSubmitAndRedirect() {
      this.windowModel = 0
      this.dialog = true

      setInterval(() => {
        if (!this.dialog) this.windowModel = 0
        else if (
          this.windowModel < this.windowPanesCount - 1 &&
          ++this.windowModel >= this.windowPanesCount
        )
          this.windowModel = 0
      }, 8000)

      logic.callAPIAndRedirect()
    },
  },
}
</script>

<style scoped>
.padTop {
  margin-top: 20px;
}
.padTopThankYouImg {
  margin-top: 50px;
}
.addPadding {
  padding: 20px;
  padding-left: 50px;
}
</style>

   
